import { Button, Col, Row, Typography } from "antd";
import { FormProvider, useFormContext } from "react-hook-form";
import {
  InputPassword,
  InputText,
  LoginLayout,
} from "../../../shared/components";
import { useLogin, FormData } from "../hooks/useLogin";
import { WrapperCardLogin, WrapperColLogin } from "./styled";

const { Title } = Typography;

export const Login = () => {
  const { isLoading, onLoginUser } = useLogin();
  const { control, handleSubmit: onSubmit } = useFormContext<FormData>();

  return (
    <LoginLayout pageDescription="Login For Users" title="Login">
      <Row justify="center" align="middle">
        <WrapperColLogin span={24}>
          <WrapperCardLogin>
          <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={"/logo_carnes_santa_cruz.png"}
                alt="logoCarnesSantaCruz"
                style={{
                  width: "50%",
                  height: "50%",
                  // minWidth: "50px",
                  // minHeight: "50px",
                  maxWidth: "120",
                  maxHeight: "110px",
                }}
              />
            </Col>
            <Col
              span={24}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Email:
              </Title>
              <InputText
                placeHolder="example@example.com"
                name="email"
                control={control}
              />
            </Col>
            <Col
              span={24}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Contraseña:
              </Title>
              <InputPassword name="password" control={control} />
            </Col>
            <Col
              span={24}
              style={{
                display: "flex",
                marginTop: "18px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Button
                style={{ width: "100%" }}
                type="primary"
                shape="round"
                size="large"
                onClick={onSubmit(onLoginUser)}
                loading={isLoading}
              >
                Ingresar
              </Button>
            </Col>
          </WrapperCardLogin>
        </WrapperColLogin>
      </Row>
    </LoginLayout>
  );
};
